import * as go from 'gojs';

export const getScreenCenterPoint = (diagram: go.Diagram, offsetX = 0, offsetY = 0) => {
  const point = diagram.viewportBounds.center;
  return new go.Point(point.x - offsetX, point.y - offsetY);
};
